// TODO: REFACTORING
import React from 'react';
import Style from './style.module.css';
import { getCookie } from '@utils/cookies.helper';

const BackButton = ({ text, onClick }) => {
  const onBackAction = () => {
    if (typeof onClick == 'function') onClick();
    else {
      const locale = getCookie('NEXT_LOCALE');

      window.history.length > 2
        ? window.history.back()
        : (window.location = `${window.location.origin}/${
            locale ? locale : ''
          }`);
    }
  };

  return (
    <div onClick={onBackAction} className={[Style.backButton].join(' ')}>
      {text}
    </div>
  );
};

export default BackButton;
